import { render, staticRenderFns } from "./LogsComp.vue?vue&type=template&id=dd36a0aa&scoped=true&"
import script from "./LogsComp.vue?vue&type=script&lang=js&"
export * from "./LogsComp.vue?vue&type=script&lang=js&"
import style0 from "./LogsComp.vue?vue&type=style&index=0&id=dd36a0aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd36a0aa",
  null
  
)

export default component.exports